import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDown, FileText } from "lucide-react";

interface ReprocessSplitButtonProps {
  variant: "ghost" | "ghostOnPrimary";
  isBusy: boolean;
  onReprocess: () => void;
  /** Present only where a decision log can be recorded; without it the button has no menu. */
  onRerunWithDecisionLog?: () => void;
}

export function ReprocessSplitButton({
  variant,
  isBusy,
  onReprocess,
  onRerunWithDecisionLog,
}: ReprocessSplitButtonProps) {
  const reprocess = (
    <Button
      variant={variant}
      onClick={onReprocess}
      disabled={isBusy}
      size="sm"
      className={onRerunWithDecisionLog ? "rounded-r-none" : undefined}
    >
      <span className="mr-1 sm:mr-2">🎯</span>
      <span className="inline">Reprocess Encounter</span>
    </Button>
  );

  if (!onRerunWithDecisionLog) return reprocess;

  return (
    <div className="flex items-center">
      {reprocess}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant={variant}
            size="sm"
            disabled={isBusy}
            aria-label="More reprocess options"
            className="rounded-l-none px-1.5 border-l border-l-current/20"
          >
            <ChevronDown className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onSelect={onRerunWithDecisionLog} className="cursor-pointer">
            <FileText className="h-4 w-4 mr-2" />
            Re-run with decision log
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
